export function getDecimalPlaces(value, places) {
    const num = parseFloat(value)
    if (isNaN(num)) return ""

    return num.toFixed(places || 2)
}